import { useCallback, useEffect, useState } from 'react';
import { getFunctions, httpsCallable } from 'firebase/functions';
import app from './config/firebase';

export const DEFAULT_CATEGORIES = [
  'Beauty Services', 'Cleaning Services', 'Construction', 'Education/Tutoring',
  'Fitness/Gym', 'General Repair', 'Healthcare', 'Home Services', 'Legal Services',
  'Mechanic/Auto Repair', 'Other', 'Pet Services', 'Photography', 'Plumbing',
  'Real Estate', 'Restaurant/Food', 'Retail/Shopping', 'Salon/Beauty',
  'Technology/IT', 'Transportation',
];

export default function useBusinessCategories(currentCategory = '') {
  const [categories, setCategories] = useState(DEFAULT_CATEGORIES);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const refresh = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const result = await httpsCallable(getFunctions(app), 'listBusinessCategories')();
      setCategories([...new Set([...DEFAULT_CATEGORIES, ...result.data.categories])].sort((a, b) => a.localeCompare(b)));
    } catch {
      setError('Could not load additional categories. Please retry.');
    } finally { setLoading(false); }
  }, []);
  useEffect(() => { refresh(); }, [refresh]);
  return { categories: [...new Set([...categories, ...(currentCategory ? [currentCategory] : [])])].sort((a, b) => a.localeCompare(b)), error, loading, refresh };
}
